import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=5121872c&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=5121872c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121872c",
  null
  
)

export default component.exports